import React from 'react'

const GmsUpgrade = () => {
  return (
    <div className="grey-bg h-100">
      <h1 className="content-header-title">Sorry...</h1>
      <div className="content-header-description">
        Gate Management System functionality is only available to those with an active GMS subscription.
        <br/>
        <br/>
        Contact our sales team today to upgrade.
      </div>
    </div>
  )
}

export default GmsUpgrade
